// AboutPage.jsx
/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React from 'react';
import About from '../Components/About/About';
import { useEffect } from 'react';
const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <About />
  );
}

export default AboutPage;